import { useState } from 'react';

interface UseSuiteFormUIStateParams {
  suiteFormData: any;
}

export interface UseSuiteFormUIStateReturn {
  uiState: any;
  patchUiState: (partial: any) => void;
}

export const useSuiteFormUIState = ({
  suiteFormData,
}: UseSuiteFormUIStateParams): UseSuiteFormUIStateReturn => {
  const [uiState, setUiState] = useState<any>({
    areas: [],
    errors: {},
    buttonPressed: '',
    value: 1,
    floorImage:
      suiteFormData && suiteFormData.floorPlanURL
        ? suiteFormData.floorPlanURL
        : null,
    loading: false,
    editorState: suiteFormData.keyHandOffInstructions
      ? suiteFormData.keyHandOffInstructions
      : '',
    orientationDate: suiteFormData.orientationDate ?? null,
    completionDate: suiteFormData.completionDate ?? null,
    posessionDate: suiteFormData.posessionDate ?? null,
  });

  const patchUiState = (partial: any) => {
    setUiState((prev: any) => ({ ...prev, ...partial }));
  };

  return { uiState, patchUiState };
};
